import {
  NJButton,
  NJModal,
  NJModalContent,
} from "@engie-group/fluid-design-system-react";
import type { Dispatch, ReactNode, SetStateAction } from "react";

/** Reusable confirmation dialog (ENGIE NJModal) — used for destructive actions (delete). */
export function ConfirmModal({
  open,
  setOpen,
  title,
  confirmLabel = "Delete",
  confirmVariant = "destructive",
  isPending,
  onConfirm,
  children,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  title: string;
  confirmLabel?: string;
  confirmVariant?: "destructive" | "primary";
  isPending?: boolean;
  onConfirm: () => void;
  children: ReactNode;
}) {
  return (
    <NJModal isOpen={open} setIsOpen={setOpen} role="alertdialog">
      <NJModalContent
        title={title}
        icon="warning"
        iconVariant="danger"
        verticalCentered
        onClose={() => setOpen(false)}
        closeLabel="Cancel"
        footer={
          <div className="flex justify-end gap-3">
            <NJButton
              label="Cancel"
              variant="secondary"
              emphasis="subtle"
              onClick={() => setOpen(false)}
            />
            <NJButton
              label={confirmLabel}
              variant={confirmVariant}
              disabled={isPending}
              onClick={onConfirm}
            />
          </div>
        }
      >
        {children}
      </NJModalContent>
    </NJModal>
  );
}
